import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-price-robot-error-display',
    templateUrl: './price-robot-error-display.component.html',
    styleUrls: ['./price-robot-error-display.component.scss']
})
export class PriceRobotErrorDisplayComponent implements OnInit {


    @Input() process_result: any;
    public niceError: string = null;
    public rawError: string = null;
    public modal: NgbModalRef;

    constructor(private modalService: NgbModal) {
    }


    ngOnInit(): void {
        if (this.process_result?.outOfStock) {
            this.niceError = 'Udsolgt';
        } else if (this.process_result?.error) {
            this.rawError = this.process_result.error;
            switch (true) {
                case /404/i.test(this.process_result.error):
                    this.niceError = '404 Fejl'
                    break;
                case /stale element/i.test(this.process_result.error):
                case /Could not start a new session/i.test(this.process_result.error):
                case /curl error thrown for http/i.test(this.process_result.error):
                case /deliveryReenque/i.test(this.process_result.error):
                    this.niceError = 'Transient Crawler Fejl'
                    break;
                case /out of stock/i.test(this.process_result.error):
                    this.niceError = 'Udsolgt (formodet)'
                    break;
                case /no such element/i.test(this.process_result.error):
                    this.niceError = 'Parser fejl (Kan være transient)'
                    break;
                default:
                    this.niceError = this.rawError;
                    break;
            }
        }
    }

    openModal(content: TemplateRef<any>) {
        this.modal = this.modalService.open(content);
    }
}
